import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { Year } from "../../types/slices/yearType";
import { reportRendition, reportType } from "../../types";

const initialState: reportType =
{
    status: ApiStatus.FETCHED,
    filter: '01',
    year: null,
    month: '' as string,
    department: null,
    owner: null,
    dataReportRendition: {} as reportRendition,
    dataReportRenditionPayment: {},
    dataReportReservation: {},
    dataReportAssignment: {},
    errorMessage: undefined,
}

const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
        onFetchDataReportRenditionPayment (state, { payload }: { payload: any }) {
            state.status       = ApiStatus.FETCHED
            state.dataReportRenditionPayment  = payload
            state.errorMessage = undefined
        },
        onFetchDataReportRendition (state, { payload }: { payload: reportRendition }) {
            state.status       = ApiStatus.FETCHED
            state.dataReportRendition  = payload
            state.errorMessage = undefined
        },
        onFetchDataReportReservation (state, { payload }: { payload: any }) {
            state.status       = ApiStatus.FETCHED
            state.dataReportReservation  = payload
            state.errorMessage = undefined
        },
        onFetchDataReportAssignment (state, { payload }: { payload: any }) {
            state.status       = ApiStatus.FETCHED
            state.dataReportAssignment  = payload
            state.errorMessage = undefined
        },
        onSetFilter (state, { payload }: { payload: any }) {
            state.status       = ApiStatus.FETCHED
            state.filter  = payload
        },
        onSetMonth (state, { payload }: { payload: any }) {
            state.status       = ApiStatus.FETCHED
            state.month  = payload
        },
        onSetYear (state, { payload }: { payload: Year | null }) {
            state.status       = ApiStatus.FETCHED
            state.year  = payload
        },
        onSetDepartment (state, { payload }: { payload: any }) {
            state.status       = ApiStatus.FETCHED
            state.department  = payload
        },
        onSetOwner (state, { payload }: { payload: any }) {
            state.status       = ApiStatus.FETCHED
            state.owner  = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
    }
})

export const selectReportState = (state: RootState) => state.reportSlice

export default reportSlice.reducer

export const {
  changeStatus,
  onFetchDataReportRendition,
  onFetchDataReportRenditionPayment,
  onFetchDataReportReservation,
  onFetchDataReportAssignment,
  onSetFilter,
  onSetMonth,
  onSetYear,
  onSetDepartment,
  onSetOwner
} = reportSlice.actions